import React from "react";
import DateHelper from "../../utils/DateHelper";
import { useCurrencySymbol } from "../../hooks/useCurrencySymbol";

export interface DuesORTransactionProps {
  id: string;
  payerPayeeName?: string;
  payeeAccountName?: string;
  description?: string;
  amount: number;
  dueDate?: string;
  paymentDate?: string;
}

interface DuesORTransactionComponentProps {
  item: DuesORTransactionProps;
}

const DuesORTransaction: React.FC<DuesORTransactionComponentProps> = ({ item }) => {
  const {
    payerPayeeName,
    payeeAccountName,
    description,
    amount,
    dueDate,
    paymentDate
  } = item;

  const currencySymbol = useCurrencySymbol();

  return (
    <div className="tab-item">
      <div className="tab-details">
        {payerPayeeName && <h6>{description}</h6>}
        {payeeAccountName && <h6>{description}</h6>}
        {dueDate && (
          <p>Due on: {DateHelper.formatDateonly(dueDate)}</p>
        )}
        {paymentDate && (
          <p>Paid on: {DateHelper.formatDateonly(paymentDate)}</p>
        )}
      </div>
      <div className="tab-amount">
        {currencySymbol}{amount.toFixed(2)}
      </div>
    </div>
  );
};

export default DuesORTransaction;